import { companyType } from '../D2r';
import { Discount } from './Discount';

export const DiscountD2r = ({ company }: { company: companyType }) => <Discount company={company} />;
